
export const TERMS_OF_SERVICE = {
  lastUpdated: '2025. március 31.',
  sections: [
    {
      title: "1. Bevezetés",
      content: 'Az Ementin Kft. (a továbbiakban: „Szolgáltató") által nyújtott szolgáltatások igénybevételével Ön elfogadja a jelen Felhasználási Feltételeket.'
    },
    {
      title: "2. Szolgáltatás Leírása",
      content: "Az Ementin Kft. különböző egészségügyi eseményekhez kapcsolódó szolgáltatásokat nyújt, beleértve az orvosi események szervezését és az egészségügyi szakemberek közötti kapcsolattartást."
    },
    {
      title: "3. Felhasználói Fiókok",
      content: "A szolgáltatások igénybevételéhez felhasználói fiók létrehozása szükséges. A felhasználó köteles a regisztráció során valós adatokat megadni."
    },
    {
      title: "4. Felhasználói Tartalmak",
      content: "A felhasználók által feltöltött tartalmakért a felhasználók felelősek. A Szolgáltató fenntartja a jogot, hogy eltávolítsa a jogsértő vagy nem megfelelő tartalmakat."
    },
    {
      title: "5. Szellemi Tulajdon",
      content: "A Szolgáltató által nyújtott szolgáltatások és tartalmak szellemi tulajdonjogai a Szolgáltatót illetik meg. A felhasználók nem jogosultak a szolgáltatások és tartalmak engedély nélküli felhasználására."
    },
    {
      title: "6. Szolgáltatás Módosítása",
      content: "A Szolgáltató fenntartja a jogot, hogy bármikor módosítsa vagy megszüntesse a szolgáltatásokat. A felhasználókat értesítjük a jelentős változásokról."
    },
    {
      title: "7. Jogviták",
      content: "A jelen Felhasználási Feltételekből eredő jogvitákra a magyar jog az irányadó. A jogvitákat a magyar bíróságok előtt kell rendezni."
    },
    {
      title: "8. Kapcsolat",
      content: "Ha kérdése vagy észrevétele van a jelen Felhasználási Feltételekkel kapcsolatban, kérjük, lépjen kapcsolatba velünk az alábbi elérhetőségeken:\n\nE-mail: info@medihub.hu\nTelefon: +36 30 088 4256"
    }
  ]
};
